import type { GetEstimatesQueryParams } from '../../../types/estimate.js'

export const estimateKeys = {
  all: ['estimates'] as const,
  clientPassengers: (clientId: string) => ['client-passengers', clientId] as const,
  clientSearch: (query: string, clientType?: string) =>
    ['client-search', query, clientType ?? null] as const,
  detail: (estimateId: string) => ['estimate-detail', estimateId] as const,
  // Préfixé par `all` : le rangement/la sortie d'un devis envoie un mail, et
  // l'invalidation existante de la liste doit rafraîchir l'historique avec elle.
  emails: (estimateId: string) => ['estimates', 'emails', estimateId] as const,
  formData: (id: string) => ['estimate-form-data', id] as const,
  list: (params: GetEstimatesQueryParams) => ['estimates', 'list', params] as const,
  /**
   * Préfixe des seules listes paginées. À utiliser dès qu'on *lit* ou *réécrit*
   * la donnée en cache (mise à jour optimiste, snapshot de rollback) : `all`
   * couvre aussi `emails`, dont la valeur est un tableau et non un
   * `GetEstimatesResponse`. Y appliquer une recopie `{ ...oldData, estimates:
   * oldData.estimates.map() }` jetait un TypeError dans `onMutate`, la mutation
   * échouait avant même de partir au serveur.
   *
   * `all` reste la bonne clé pour les invalidations, qui, elles, doivent bien
   * emporter l'historique des mails avec la liste.
   */
  lists: () => ['estimates', 'list'] as const,
}
